import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {LoginServerService} from "src/app/layouts/public/login/services/login-server.service";
import { isNullOrUndefined } from 'src/app/helpers/tools';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationCheckService  {

    constructor(private router: Router, public loginService: LoginServerService) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return await this.checkUser(route, state);
    }

    async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return await this.checkUser(childRoute, state);
    }

    private async checkUser(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const userDetail = this.loginService.userToken;

        if (userDetail && userDetail.unique_name) {
            if (!this.loginService.isNewUser() &&
                isNullOrUndefined(userDetail.Rata_AccountId) && isNullOrUndefined(userDetail.Rata_LaboratoryGroupId) &&
                isNullOrUndefined(userDetail.Rata_DistributorId) && isNullOrUndefined(userDetail.Rata_LaboratoryId)) {
                await this.router.navigate(['login', 'select-account'], { queryParams: { returnUrl: state.url } });
                
                return false;
            }
            else {
                return true;
            }
        }
        else {
            console.log("Auth check failed, logging out user.");
            await this.loginService.localLogout(state.url);
            return false;
        }
    }

}
